import React from 'react';

import { FaCameraRetro, FaMoneyBillWave, FaUsers, FaUtensils } from 'react-icons/fa';

import { StyledSocialProof } from './styles';
import { Heading2, Paragraph1, Paragraph2, SectionTitle, StatValue } from '../../../theme';
import { bemClassName } from '../../../utils/bem';

const b = bemClassName('social-proof');

const HIGHLIGHTS = [
  { icon: FaUsers, value: '10K+', label: 'Active Users' },
  { icon: FaUtensils, value: '5,000+', label: 'Recipes Available' },
  { icon: FaCameraRetro, value: '1M+', label: 'Meals Scanned' },
  { icon: FaMoneyBillWave, value: '$25K+', label: 'Paid to Referrers' },
];

const SocialProof = () => {
  return (
    <StyledSocialProof>
      <div className={b()}>
        <div className={b('header')}>
          <Heading2>EVERYTHING YOU NEED</Heading2>
          <SectionTitle>Built for Real Progress</SectionTitle>
        </div>

        <div className={b('stats')}>
          {HIGHLIGHTS.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.label} className={b('stat-item')}>
                <div className={b('stat-icon')}>
                  <Icon />
                </div>
                <div className={b('stat-value')}>
                  <StatValue>{item.value}</StatValue>
                </div>
                <div className={b('stat-label')}>
                  <Paragraph2>{item.label}</Paragraph2>
                </div>
              </div>
            );
          })}
        </div>

        <div className={b('features-summary')}>
          <div className={b('feature-block')}>
            <div className={b('feature-block-title')}>
              <Paragraph1>AI-Powered Nutrition</Paragraph1>
            </div>
            <div className={b('feature-block-text')}>
              <Paragraph1>
                Scan your meals with AI for instant calorie and macro breakdowns. Get a personalized nutrition plan with
                daily targets, meal timing, and hydration goals, all tailored to your profile and goals.
              </Paragraph1>
            </div>
          </div>
          <div className={b('feature-block')}>
            <div className={b('feature-block-title')}>
              <Paragraph1>Comprehensive Tracking</Paragraph1>
            </div>
            <div className={b('feature-block-text')}>
              <Paragraph1>
                Track calories, macros, weight, water intake, steps, exercise, supplements, and fasting sessions in one
                place. Active Shape connects the dots so you see the full picture of your health.
              </Paragraph1>
            </div>
          </div>
          <div className={b('feature-block')}>
            <div className={b('feature-block-title')}>
              <Paragraph1>Insights That Explain Why</Paragraph1>
            </div>
            <div className={b('feature-block-text')}>
              <Paragraph1>
                Daily AI insights analyze your data to explain trends, detect plateaus, and give you actionable
                recommendations that go beyond numbers and actually help you understand your progress.
              </Paragraph1>
            </div>
          </div>
        </div>
      </div>
    </StyledSocialProof>
  );
};

export default SocialProof;
